import { getEnvironment, noop } from '@sail/utils';
export const DEFAULT_OBSERVABILITY_CONFIG = {
    project: 'sail_core',
    service: 'sail-core',
    errors: {
        projects: {
            sail_core: getEnvironment() === 'production' ? 'https://28219678049240a7b5ccd5c4fa8075fe@errors.stripe.com/992' : 'https://e78e80651cc645a1bab10afbcb4a7e28@qa-errors.stripe.com/853'
        }
    }
};
export const QUIESCENCE_WINDOW = 5000;
export const DEFAULT_SET_AND_UNSET_VALUE = {
    set: noop,
    unset: noop
};
export const DEFAULT_START_STOP_VALUE = {
    start: noop,
    stop: noop
};
export const DEFAULT_TRACK_CHILD_VALUE = ()=>noop;
export const DEFAULT_DEBUG_BOUNDARY_VISIBLE = [
    new Set(),
    noop
];

//# sourceMappingURL=constants.js.map